module.exports = __webpack_public_path__ + "static/media/orders-truck.2bbbb826.svg";